import apiVirtus from './apiVirtus';

// Serviços de PIX imediato (QR Code + copia e cola) consumidos pelo portal.
// Reusa os endpoints genéricos do backend-virtus com origin=portal.
// O `origin` é apenas uma string repassada (sem validação de enum no backend).

const authHeader = token => ({
  headers: { Authorization: 'Bearer ' + token },
});

// Gera uma cobrança PIX imediata. Retorna { message, pix: { image_qr_code_b64,
// pixCopiaECola, txid, valor, status, expiracao } }.
export const generatePix = async (payload, token) => {
  const { data } = await apiVirtus.post(
    '/cobranca/charges/payments/pix/portal/save?env=prod',
    payload,
    authHeader(token),
  );
  return data;
};

// Consulta o status do PIX. Retorna uma string: REGISTRADO | LIQUIDADO |
// NAO_ENCONTRADO | etc. Ao detectar LIQUIDADO, o backend também emite o evento
// de WebSocket `paymentStatusUpdate`.
export const validatePix = async (txid, token) => {
  const { data } = await apiVirtus.get(
    `/cobranca/charges/payments/pix/validate/${txid}`,
    authHeader(token),
  );
  return data;
};

// Cancela cobranças PIX em aberto do contrato (não cancela as já liquidadas).
export const cancelPix = async ({ contrato, cnpj, cgcCliente }, token) => {
  const { data } = await apiVirtus.delete(
    `/cobranca/pix/cancelation/charge/${contrato}/${cnpj}/${cgcCliente}`,
    authHeader(token),
  );
  return data;
};
